import { Injectable } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SignupService {

  signUpCompanyUrl = `${AppSettings.API_ENDPOINT}/${'get_company_validity'}`;
  signUpUrl = `${AppSettings.API_ENDPOINT}/${'sign-up'}`;

  constructor(private http: HttpClient) { }

  getCompanyValidity(){
    return this.http.get(this.signUpCompanyUrl);
  }

  signUp(data:any){
    return this.http.post(this.signUpUrl, data);
  }

} 